import { render, staticRenderFns } from "./SupplyCommonPartDrawer.vue?vue&type=template&id=674dd02a&scoped=true"
import script from "./SupplyCommonPartDrawer.vue?vue&type=script&lang=js"
export * from "./SupplyCommonPartDrawer.vue?vue&type=script&lang=js"
import style0 from "./SupplyCommonPartDrawer.vue?vue&type=style&index=0&id=674dd02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674dd02a",
  null
  
)

export default component.exports